"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Fri Aug 03 2018
 */

var DataObjectConverter_1 = require("../../../conversions/DataObjectConverter");
/**
 * Form field definition converter.
 *
 * @author Radek Beran
 */


var FormFieldConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(FormFieldConverter, _DataObjectConverter_);

  function FormFieldConverter() {
    _classCallCheck(this, FormFieldConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(FormFieldConverter).apply(this, arguments));
  }

  return FormFieldConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.FormFieldConverter = FormFieldConverter;